import type { LegalDocumentId } from '@falasta/contracts';
import { createApp, type Component } from 'vue';

import LegalApp from '../app/LegalApp.vue';
import '../styles/global.css';

/**
 * Monta una pagina legale.
 *
 * Un file HTML per documento, e quindi un punto d'ingresso per documento: sono
 * tre righe ciascuno, e tutti passano da qui perché il montaggio è identico.
 * Come in `main.ts`, `LegalApp.vue` è tipizzato dal plugin Vue del bundler e non
 * dal solo `tsc`.
 */
export function mountLegalPage(document: LegalDocumentId): void {
  createApp(LegalApp as Component, { document }).mount('#app');
}
